import React, { useState, useContext } from "react";
import "./Login.css";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

import fliplynVendor from "../../../Assets/vendor img.png";
import { AuthContext } from "../../../ContextAPI/VendorAuthContext";

const Login = () => {

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {

    e.preventDefault();
    setError("");

    try {

      setLoading(true);

      const res = await axios.post(
        "https://fliplyn-b-c.fly.dev/api/vendor/auth/login",
        {
          phone_number: phone,
          password: password
        }
      );

      const token = res.data.access_token;

      console.log("Access Token:", token);

      // Decode JWT
      const decoded = jwtDecode(token);

      console.log("Decoded Token:", decoded);

      const vendorData = {
        token: token,
        vendorId: decoded.owner_id,
        phoneNumber: decoded.phone_number
      };

      console.log("Vendor ID:", vendorData.vendorId);
      console.log("Vendor Data Stored:", vendorData);

      // Save vendor data in context
      login(vendorData);

      // Redirect to vendor outlet page
      navigate("/vendor-Outtlet");

    } catch (err) {

      console.error("Login Error:", err);

      setError(
        err?.response?.data?.detail ||
        "Login failed. Please check credentials."
      );

    } finally {

      setLoading(false);

    }
  };

  return (

    <div className="login-wrapper">

      {/* LEFT SIDE */}
      <div className="login-left">

        <img
          src={fliplynVendor}
          alt="vendor"
          className="vendor-illustration"
        />

        <h1 className="title">Smart. Fast. Empowered.</h1>

        <p className="sub">
          Manage your Fliplyn Vendor workspace with confidence.
        </p>

        <span className="footer">
          ©2025 Fliplyn Vendor Portal · Secure Access
        </span>

      </div>


      {/* RIGHT SIDE */}
      <div className="login-right">

        <div className="login-box">

          <h2>Vendor Sign In</h2>

          <p className="tagline">
            Sign in to manage outlets and orders.
          </p>

          {error && (
            <p style={{ color: "red", marginBottom: "10px" }}>
              {error}
            </p>
          )}

          <form onSubmit={handleSubmit} className="login-form">

            <label>Phone number</label>

            <input
              type="text"
              placeholder="Enter phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />

            <label>Password</label>

            <div className="password-wrapper">

              <input
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <i className="eye-icon">👁</i>

            </div>

            <button
              type="submit"
              className="login-btn"
              disabled={loading}
            >
              {loading ? "Signing In..." : "Sign in"}
            </button>

            <div className="need-access">
              Need access? <span>Contact admin</span>
            </div>

          </form>

        </div>

      </div>

    </div>

  );
};

export default Login;